import { AuthProvider } from '@cw-elements/auth-provider';
import type { ReactNode } from 'react';
import { AppConstants } from 'utils/app.constants';
import { request } from 'utils/axios';
import { AUTHENTICATE_PATH } from './auth.constants';

interface AppAuthProviderProps {
  children: ReactNode;
}

export const AppAuthProvider = ({ children }: AppAuthProviderProps) => {
  const environment = process.env.REACT_APP_CW_ELEMENTS_ENVIRONMENT as 'qa' | 'staging' | 'prod';

  return (
    <AuthProvider
      environment={environment}
      redirectUri={`${window.location.origin}${AUTHENTICATE_PATH}`}
      clientId={AppConstants.OAUTH_CLIENT_ID}
      axiosInstance={request}
    >
      {children}
    </AuthProvider>
  );
};
